import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { useState } from "react";

import type { ReactElement, ReactNode } from "react";

interface Column<T> {
  label: string;
  value: (row: T) => ReactNode;
}
export default function AnalyticsRowsTable<T>({
  rows,
  columns,
  label,
}: {
  rows: T[];
  columns: Column<T>[];
  label: string;
}): ReactElement {
  const [page, setPage] = useState(0);
  const currentPage = Math.min(
    page,
    Math.max(0, Math.ceil(rows.length / 25) - 1),
  );
  return (
    <>
      <TableContainer>
        <Table size="small" aria-label={label}>
          <TableHead>
            <TableRow>
              {columns.map(
                (column): ReactElement => (
                  <TableCell key={column.label}>{column.label}</TableCell>
                ),
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.slice(currentPage * 25, currentPage * 25 + 25).map(
              (row, index): ReactElement => (
                <TableRow key={index}>
                  {columns.map(
                    (column): ReactElement => (
                      <TableCell key={column.label}>
                        {column.value(row)}
                      </TableCell>
                    ),
                  )}
                </TableRow>
              ),
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={rows.length}
        page={currentPage}
        rowsPerPage={25}
        rowsPerPageOptions={[25]}
        onPageChange={(_event, next): void => setPage(next)}
      />
    </>
  );
}
